import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer
}: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-443" data-mp="2k683jd9m6d4c">
      <div ref={overlayRef} className="fixed inset-0 bg-black/50 transition-opacity backdrop-blur-sm" onClick={onClose} data-id="element-444" data-mp="2f62gybi7bgt4" />
      
      <div className="relative w-full max-w-lg transform rounded-xl bg-white shadow-2xl transition-all flex flex-col max-h-[90vh]" data-id="element-445" data-mp="2i1uxs12r0fh4">
        <div className="flex items-center justify-between border-b border-slate-100 px-6 py-4" data-id="element-446" data-mp="2861elyuixnqd">
          <h3 className="text-lg font-semibold text-slate-900" data-id="element-447" data-mp="2d4369860mvdg">{title}</h3>
          <Button variant="ghost" size="icon" onClick={onClose} className="h-8 w-8 rounded-full" data-id="element-448" data-mp="2d6fjx94qqjkp">
            
            <X className="h-4 w-4" data-id="element-449" data-mp="245hgary7se2n" />
          </Button>
        </div>
        <div className="px-6 py-4 overflow-y-auto" data-id="element-450" data-mp="1pfjweo7biaj9">{children}</div>
        {footer && <div className="border-t border-slate-100 px-6 py-4 bg-slate-50 rounded-b-xl" data-id="element-451" data-mp="1udv6n01iyn20">
            {footer}
          </div>}
      </div>
    </div>;
}